export const menuList = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Events',
    path: '/events',
  },
];